import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { feedfooterActions } from "../../actions";
import { createMarkup, useScript } from "../../../helpers";
// import TextContentHeader from "../Utils/TextContentHeader";
// import { userActions } from "../../../Member/actions";
// import { MailIcon, PhoneIcon } from "@heroicons/react/outline";
// import { Link } from "react-router-dom";
function FooterSection() {
    useScript("info/smartmenu/jquery.smartmenus.js");

    const feedFooter = useSelector((state) => state.feedFooter);
    const feedManu = useSelector((state) => state.feedManu);
    const authentication = useSelector((state) => state.authentication);
    const feedData = useSelector((state) => state.feedData);
    // const state = useSelector(state => state);
    const dispatch = useDispatch();

    // const [loading, setLoading] = useState(true);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        // async function feedData() {
        //     await dispatch(
        //         feedfooterActions.feedfooterData(`/api/info/infofooter`)
        //     );
        // }
        // feedData();
    }, []);
    useEffect(() => {
        if (feedFooter.fetchSuccess) {
            setLoading(false);
        }
        return async function cleanup() {
            await setLoading(true);
        };
    }, [feedFooter.fetchSuccess]);

    const SocialMedia = [
        {
            label: "Facebook",
            url: `https://www.facebook.com/profile.php?id=100057414402317`,
            image: `/info/img/facebook.png`,
        },
        {
            label: "Line",
            url: `https://line.me/ti/p/~@coop_army3`,
            image: `/info/img/line.png`,
        },
        // { label: "Location", url: `https://www.facebook.com`, image: `/mediafiles/images/Utils/map.png`, },
    ];

    return (
        <Fragment>
            {loading && <Fragment>&nbsp;</Fragment>}
            {!loading && (
                <footer className="w-full bg-[#1363DF] bg-cover ">
                    <div className="mx-auto bg-[#1363DF] max-w-7xl flex gap-5 justify-between lg:flex-nowrap flex-wrap text-white px-3 md:py-8 py-4">
                        <div className=" items-center lg:m-0 m-auto">
                            <p className="md:text-2xl sm:text-xl text-lg text-center lg:text-start font-medium pb-4">
                                เวลาเปิดทำการ
                            </p>
                            <p className="lg:pl-2 pl-0 text-sm sm:text-base md:text-lg text-center lg:text-start">
                                จันทร์ - ศุกร์ เวลา 08.30 - 16.30 น.<br />
                                ยกเว้นวันหยุดราชการ
                            </p>
                        </div>
                        <div className="grid justify-center m-auto gap-2">
                            <p className="md:text-2xl sm:text-xl text-lg text-center font-medium pb-4">ติดต่อเรา</p>
                            <div className="flex items-center gap-3 sm:gap-5">
                                <div className="w-16 sm:w-[5.2rem] md:w-24 lg:w-[6.2rem] xl:w-24">
                                    <img src="/info/img/map.png" alt="map" className="ml-auto w-4 h-5 sm:w-fit sm:h-fit" />
                                </div>
                                <p className="text-xs sm:text-base md:text-lg">สหกรณ์ออมทรัพย์กองทัพภาคที่ 3 จำกัดสำนักงานใหญ่</p>
                            </div>
                            <div className="flex items-center gap-3 sm:gap-5">
                                <p className="text-xs sm:text-base md:text-lg font-medium w-16 sm:w-[5.2rem] md:w-24 lg:w-[7.2rem] xl:w-24 text-right">&nbsp;</p>
                                <p className="text-xs sm:text-base md:text-lg">{window.config.coop_address}</p>
                            </div>
                            <div className="flex items-center gap-3 sm:gap-5">
                                <div className="w-16 sm:w-[5.2rem] md:w-24">
                                    <img src="/info/img/call.png" alt="call" className="ml-auto w-4 h-4 sm:w-fit sm:h-fit" />
                                </div>
                                <p className="text-xs sm:text-base md:text-lg">0-5521-0105 , 0-5530-2170</p>
                            </div>
                            <div className="flex items-center gap-3 sm:gap-5">
                                <p className="text-xs sm:text-base md:text-lg font-medium w-16 sm:w-[5.2rem] md:w-24 text-right">แฟกซ์</p>
                                <p className="text-xs sm:text-base md:text-lg">
                                    02-504-0123 ต่อ 1131–1135 ,1050–1053,1139
                                </p>
                            </div>
                            <div className="flex items-center gap-3 sm:gap-5">
                                <p className="text-xs sm:text-base md:text-lg font-medium w-16 sm:w-[5.2rem] md:w-24 text-right">สื่อสารทหาร</p>
                                <p className="text-xs sm:text-base md:text-lg">
                                    73893 , 73894
                                </p>
                            </div>
                            <div className="flex items-center gap-3 sm:gap-5">
                                <div className="w-16 sm:w-[5.2rem] md:w-24">
                                    <img src="/info/img/gmail.png" alt="mail" className="ml-auto w-5 h-4 sm:w-fit sm:h-fit" />
                                </div>
                                <p className="text-xs sm:text-base md:text-lg">cooparmy3@gmail.com</p>
                            </div>
                        </div>

                        {/* <div className=" items-center gap-2 grid justify-center lg:justify-start lg:m-0 m-auto">
                            <p className="text-2xl text-center font-medium pb-4">
                                ติดต่อเรา
                            </p>
                            <div className="sm:justify-start justify-center flex items-center">
                                <div className="h-[35px] w-[100px] sm:flex hidden">
                                    <img
                                        src="/info/img/map.png"
                                        alt="map"
                                        className="w-[27px] h-[35px] mr-5 object-cover ml-auto"
                                    />
                                </div>
                                <p className="text-base md:text-lg text-center ">
                                    สหกรณ์ออมทรัพย์กองทัพภาคที่ 3 จำกัดสำนักงานใหญ่
                                </p>

                            </div>
                            
                            <div className="sm:justify-start justify-center lg:text-start flex">
                                <span className="w-[100px] h-[35px] sm:flex hidden" />
                                <p className="text-sm md:text-lg text-center ">{window.config.coop_address}</p>

                            </div>
                            <div className="sm:justify-start justify-center flex items-center">
                                <span className="sm:hidden font-medium flex pr-2">โทร</span>
                                <div className="h-[26px] w-[100px] my-auto sm:flex hidden">
                                    <img
                                        src="/info/img/call.png"
                                        alt="call"
                                        className="w-[28px] h-[26px] mr-5 object-cover ml-auto"
                                    />
                                </div>
                                <p className="text-base md:text-lg text-center ">0-5521-0105 , 0-5530-2170</p>

                            </div>
                            <div className="sm:justify-start justify-center flex items-center">
                                <div className="sm:w-[100px] w-fit pr-5">
                                    <p className="font-medium text-right">แฟกซ์</p>
                                </div>
                                <p className="text-base md:text-lg text-center ">
                                    02-504-0123 ต่อ 1131–1135 ,1050–1053,1139
                                </p>
                                

                            </div>
                            <div className="sm:justify-start justify-center flex items-center">
                                <div className="w-fit pr-5">
                                    <p className="font-medium text-right">สื่อสารทหาร</p>
                                </div>
                                <p className="text-base md:text-lg text-center ">
                                    73893 , 73894
                                </p>
                               

                            </div>
                            <div className="sm:justify-start justify-center flex items-center">
                                <div className="h-[25px] w-[100px] my-auto sm:flex hidden">
                                    <img
                                        src="/info/img/gmail.png"
                                        alt="mail"
                                        className="w-[33px] h-[25px] mr-5 object-cover ml-auto"
                                    />
                                </div>
                                <p className="text-base md:text-lg text-center ">
                                    cooparmy3@gmail.com
                                </p>

                            </div>
                        </div> */}
                        <div className="xl:w-[300px] lg:w-[240px] w-[300px] lg:m-0 m-auto">
                            <div className="w-fit xl:ml-auto m-auto">
                                <p className="md:text-2xl sm:text-xl text-lg text-center font-medium pb-4">
                                    ช่องทางติดต่อ
                                </p>
                                <div className="flex gap-6 my-3 justify-center">
                                    {SocialMedia.map((value) => {
                                        return (
                                            <Fragment>
                                                <a
                                                    href={value.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img
                                                        src={value.image}
                                                        alt={value.label}
                                                        className={`w-14 h-14 hover:scale-105 ease-out duration-300`}
                                                    />
                                                </a>
                                            </Fragment>
                                        );
                                    })}
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="container">
                        <hr className="xl:w-full w-5/6 m-auto text-white h-[2px]" />
                    </div>

                    <div className="text-center bg-[#1363DF] intro-y px-10 py-4">
                        <h2

                            className="bg-none text-white text-sm md:text-md"
                        >
                            Copyright © 2023 All Right Reserved SSCBD@
                            <a
                                href="https://www.soatsolution.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-gray-50"
                            >
                                SO-AT
                            </a>
                            Solution.co.,ltd.@2023 ENhance Security for Web Application Systems.
                        </h2>
                    </div>
                </footer>
            )}
        </Fragment>
    );
}

export default FooterSection;
